/**
 * @file Page footer
 */

import React from "react"
import styled from "styled-components"

import { LayoutContext } from "packages/web-layout/context"

export interface FooterProps {
  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  limitWidth?: boolean;
  children?: React.ReactNode
}

export const Footer: React.FC<FooterProps> = ({
  style,
  contentStyle,
  limitWidth = false,
  children,
}) => {
  const { collapsed } = React.useContext(LayoutContext)
  return (
    <FooterWrapper style={{ left: collapsed ? 68 : 240, ...style }}>
      <Content style={contentStyle} limitWidth={limitWidth}>
        {children}
      </Content>
    </FooterWrapper>
  )
}

const FooterWrapper = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 101;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 57px;
  background-color: '#fff';
  border: 1px solid rgba(50, 56, 66, 0.1);
`

const Content = styled.div<{ limitWidth: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  ${({ limitWidth }) => limitWidth && "max-width: 1312px;"}
`
